import { canValidateOpgavekompleksetTask } from '@utils/component-framework';
import { useToggleState, useTransitionState, SizeTransition } from '@utils/react';
import { TaskContext } from '../../components/organism.task/context.js';
import { useOpgavekompleksetComponent } from '../../state/context.data.js';
import { useOpgavekompleksetEntry } from '../../state/hook.entry.js';
import { shouldShowReport } from '../../state/util.should-show-report.js';
import { transitionDurationMs, details, content } from './_task-accordion.style.js';
import { TaskAccordionContent } from './molecule.content.js';
import { TaskAccordionSummary } from './molecule.summary.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function TaskAccordion(props) {
  const [isExpanded, actions] = useToggleState();
  const transitionState = useTransitionState(isExpanded, transitionDurationMs);
  const showExpandedState = isExpanded || transitionState !== "exited";
  const component = useOpgavekompleksetComponent();
  const canValidate = canValidateOpgavekompleksetTask(props.task);
  const isSkipped = useOpgavekompleksetEntry({
    select: entry => entry?.data.tasks[props.task.id]?.state.skipped ?? true
  });
  return /*#__PURE__*/jsx(TaskContext.Provider, {
    value: shouldShowReport(component.data.settings.flowType) && canValidate && !isSkipped ? "facit" : "readonly",
    children: /*#__PURE__*/jsxs("details", {
      open: showExpandedState,
      className: details,
      children: [/*#__PURE__*/jsx(TaskAccordionSummary, {
        ...props,
        onToggle: actions.toggle,
        expanded: isExpanded
      }), /*#__PURE__*/jsx(SizeTransition, {
        in: isExpanded,
        axis: "vertical",
        timeout: transitionDurationMs,
        classNames: content,
        getMaxSizeInPx: () => ({
          height: window.innerHeight
        }),
        delayMs: {
          enter: 10,
          exit: 0
        },
        mountOnEnter: true,
        unmountOnExit: true,
        children: ref => /*#__PURE__*/jsx("div", {
          ref: ref,
          className: content,
          children: /*#__PURE__*/jsx(TaskAccordionContent, {
            task: props.task,
            taskIndex: props.index
          })
        })
      })]
    })
  });
}

export { TaskAccordion };
//# sourceMappingURL=_task-accordion.js.map
